export const drawMesh = (faces, ctx) => {
    if (!faces || faces.length === 0) return; // ✅ Prevents undefined keypoints error
  
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  
    faces.forEach((face) => {
      const keypoints = face.keypoints || face.landmarks || [];
  
      if (!keypoints || keypoints.length === 0) return; // ✅ Ensures keypoints exist before drawing
  
      ctx.strokeStyle = "red";
      ctx.lineWidth = 2;
  
      keypoints.forEach((point) => {
        if (!point || !point.x || !point.y) return; // ✅ Prevents drawing invalid points
        ctx.beginPath();
        ctx.arc(point.x, point.y, 2, 0, 2 * Math.PI);
        ctx.fillStyle = "red";
        ctx.fill();
        ctx.stroke();
      });
    });
  };
  